var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { space, letterSpacing, lineHeight, fontWeight, borderBottom, borderColor, order, display, flexWrap, alignItems, maxWidth, minWidth, } from 'styled-system';
import dayjs from 'dayjs';
import { Text } from '../../common/components/Text';
// To get the difference in days-hours-minutes-seconds between today and a given date,
// considering the midnight as deadline.
var getTimeLeft = function (endDate) {
    var now = dayjs();
    var deadline = dayjs(endDate).endOf('day');
    return deadline.isBefore(now)
        ? {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
        }
        : {
            days: dayjs(deadline).diff(now, 'day'),
            hours: deadline.hour() - now.hour(),
            minutes: deadline.minute() - now.minute(),
            seconds: deadline.second() - now.second(),
        };
};
var addLeadingZero = function (value) { return (value < 10 ? "0" + value : value); };
var CountDownContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), display, flexWrap, alignItems, space, order);
CountDownContainer.defaultProps = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'baseline',
    fontSize: [4, null, null, 5],
    mb: [null, '28px', '66px', '72px'],
    order: [3, 1],
};
var CountDownLabel = styled(Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  ", ";\n  ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])), maxWidth, lineHeight);
CountDownLabel.defaultProps = {
    as: 'p',
    maxWidth: '147px',
    lineHeight: 3,
    mt: 0,
    mb: [3, 0],
};
var Timer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), fontWeight, letterSpacing, borderBottom, borderColor, space, minWidth);
Timer.defaultProps = {
    fontWeight: 'bold',
    letterSpacing: '2px',
    borderBottom: '2px solid',
    borderColor: 'gray.5',
    ml: '10px',
    minWidth: '110px',
};
var TIMER_INTERVAL = 1000;
var CountDown = /** @class */ (function (_super) {
    __extends(CountDown, _super);
    function CountDown(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            timeLeft: getTimeLeft(props.endDate),
        };
        _this.tick = _this.tick.bind(_this);
        return _this;
    }
    CountDown.prototype.componentDidMount = function () {
        this.timer = setInterval(this.tick, TIMER_INTERVAL);
    };
    CountDown.prototype.componentWillUnmount = function () {
        clearInterval(this.timer);
    };
    CountDown.prototype.tick = function () {
        var _this = this;
        this.setState(function (_, _a) {
            var endDate = _a.endDate;
            return ({ timeLeft: getTimeLeft(endDate) });
        }, function () {
            var endDate = _this.props.endDate;
            var deadline = dayjs(endDate).endOf('day');
            if (deadline.isBefore(dayjs())) {
                clearInterval(_this.timer);
            }
        });
    };
    CountDown.prototype.render = function () {
        var label = this.props.label;
        var _a = this.state.timeLeft, days = _a.days, hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
        return (React.createElement(CountDownContainer, null,
            React.createElement(CountDownLabel, { "data-testid": "count-down-label" }, label),
            React.createElement(Timer, { "data-testid": "count-down-timer" },
                addLeadingZero(days),
                ":",
                addLeadingZero(hours),
                ":",
                addLeadingZero(minutes),
                ":",
                addLeadingZero(seconds))));
    };
    CountDown.propTypes = {
        /** Countdown label */
        label: PropTypes.string.isRequired,
        /** Countdown end Date */
        endDate: PropTypes.string.isRequired,
    };
    return CountDown;
}(React.Component));
export default CountDown;
var templateObject_1, templateObject_2, templateObject_3;
